/**
 * @Description 拓店任务中解除机会点绑定
 */

import { FC, useEffect } from 'react';
import { Form, Modal } from 'antd';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import { releaseAssociate } from '@/common/api/expandStore/expansiontask';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2Form from '@/common/components/Form/V2Form';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';
import V2FormUpload from '@/common/components/Form/V2FormUpload/V2FormUpload';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

export interface ReleaseData {
  id: number;
  open: boolean;
}

interface ReleaseChanceProps {
  chancepointAlias?: string;
  modalData: ReleaseData;
  setModalData: Function;
  refresh?: Function;
}
const ReleaseChance: FC<ReleaseChanceProps> = ({
  chancepointAlias,
  modalData,
  setModalData,
  refresh
}) => {
  const [form] = Form.useForm();
  const { open, id } = modalData;

  useEffect(() => {
    // 操作解除的点位变动时清空
    id && form.resetFields();
  }, [id]);

  const methods = useMethods({
    handleSubmit: () => {
      form.validateFields().then((res: any) => {
        const { reason, attachment } = res || {};
        const urls = isArray(attachment) ? attachment.map(itm => itm.url) : [];
        const params: any = {
          id: +id,
          releaseReason: reason,
          releaseUrls: urls
        };
        releaseAssociate(params).then(() => {
          V2Message.success('操作成功');
          setModalData({
            open: false,
            id: null
          });
          form.resetFields();
          refresh?.();
        });
      });
    }
  });
  return (
    <Modal
      title={`${chancepointAlias}解除原因`}
      open={open}
      maskClosable={false}
      width={420}
      onCancel={() => setModalData((state) => ({ ...state, open: false }))}
      onOk={methods.handleSubmit}
    >
      <V2Form form={form}>
        <V2FormTextArea
          label='申请理由'
          name='reason'
          placeholder='请输入理由，最多输入50字'
          maxLength={50}
          config={{ showCount: true }}
          required
          rules={[{
            required: true, message: '请输入理由'
          }]}
        />
        <V2FormUpload
          label='上传凭证'
          name='attachment'
          uploadType='image'
          config={{
            maxCount: 3,
            size: 50,
            fileType: ['png', 'jpg', 'jpeg', 'bmp', 'webp'],
          }}
        />
      </V2Form>
    </Modal>
  );
};

export default ReleaseChance;
